module.exports = __webpack_public_path__ + "img/222-niger.6ee212a5.svg";